import { createContext } from "react";

import type { Config } from "@jti/fe-common/config";

export const ConfigContext = createContext<Config | null>(null);
export const LocaleContext = createContext<string | null>(null);
